import { Map3dMaterial } from "./materials.map";
export class EllipsoidalMapMaterial extends Map3dMaterial {
    constructor(name, scene) {
        super(name, scene, EllipsoidalMapMaterial.ShaderName);
    }
    getClassName() {
        return EllipsoidalMapMaterial.ClassName;
    }
}
EllipsoidalMapMaterial.ClassName = "EllipsoidalMapMaterial";
EllipsoidalMapMaterial.ShaderName = "ellipsoidalmap";
//# sourceMappingURL=materials.ellipsoidalMap.js.map